/****************
 * Home events  *
 ****************/

$('body').on('click', '#request-poc', function (e) {
    $('#poc-request-form').submit();
});